import AccountIconWh104 from '../../../components/atoms/account_icons/AccountIconWh104'
export default {
  components: { AccountIconWh104 },
  data() {
    return {
      isInfoPublicChecked: true
    }
  },
  mounted() {
    const infoPublic = document.querySelector('#info_public').value

    if (infoPublic === 'false') {
      this.isInfoPublicChecked = false
    }
  },
  methods: {
    onInfoPublicCheck() {
      this.isInfoPublicChecked = !this.isInfoPublicChecked
    }
  }
}
